import { ClassNameProps, Item } from '../../../types/types';
import Social from '../../../components/Social/Social';
import { connectionItems, socialMediaItems } from '../../../data/data';
const SocialMedia = ({ className }: ClassNameProps) => {
  return (
    <>
      {socialMediaItems.map((item: Item) => (
        <div className={`${className} card`} key={item.id}>
          <div className={`${className}__inner`}>
            {item.img && (
              <img
                src={item.img}
                className={`${className}__img`}
                alt={item.title}
              />
            )}
            {item.svg && <>{item.svg}</>}
            <h3 className={`${className}__title subtitle`}>{item.title}</h3>
            <Social className='social' social={connectionItems} />
            <p className={`${className}__text text-normal`}>{item.text}</p>
          </div>
        </div>
      ))}
    </>
  );
};
export default SocialMedia;
